export const localStorageKeySelectedMap = "pmap::selectedMap";

// Fitbounds to the markers showing on the map
export const FIT_MARKERS_TOPIC = "googlemap.fitmarkers";
